import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from "./store";
import App from './App.vue'

document.addEventListener('DOMContentLoaded', () => {
    let app = createApp(App);
    app.use(VueAxios, axios);
    app.use(store);
    app.mount('#app');
});
